import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core'
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog
} from '@angular/material/dialog'
import html2canvas from 'html2canvas'
import jspdf, { jsPDF } from 'jspdf'
import { ToastrService } from 'ngx-toastr'
import { NgxUiLoaderService } from 'ngx-ui-loader'
import { takeWhile } from 'rxjs/operators'
import { AggregatorService } from 'src/app/services/aggregator/aggregator.service'
import * as $ from 'jquery'
import { AggregatorRejectModal } from '../rejectmodal/reject.component'
import { Router } from '@angular/router'
import { AuthenticationService } from 'src/app/components/login/authentication.service'

@Component({
  selector: 'app-example-dialog',
  templateUrl: 'aggreement.component.html',
  styleUrls: ['aggreement.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Aggrement implements OnInit, OnDestroy {
  @ViewChild('contentToConvert', { static: true })
  el!: ElementRef<HTMLImageElement>
  @ViewChild('pdfTable') pdfTable!: ElementRef
  html: any
  idtoApprove: any
  isAlive: boolean = true
  disabled: boolean = true
  resendBtn: boolean = false
  rejectBtn: boolean = false
  someHtmlCode
  @ViewChild('isApproved') isApproved

  constructor(
    public dialogRef: MatDialogRef<Aggrement>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _httpService: AggregatorService,
    private tostr: ToastrService,
    private loader: NgxUiLoaderService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog,
  ) {
    this.html = data.data

    this.idtoApprove = data.id.idAggregatorData
  }

  ngOnInit(): void {
    let getHtmlData = this.data.data
    console.log(this.data.data)
    var doc = new DOMParser().parseFromString(getHtmlData, "text/html");
    let IsApproved = doc.getElementById('IsApproved').textContent
    let mouAccept = doc.getElementById('mouAccept').textContent
    if (this.data.status == 1) {
      if (IsApproved == mouAccept) {
        this.resendBtn = true
      } else {
        this.resendBtn = false
      }
      if (this.data.status == '1') {
        this.rejectBtn = true
      }
    }
    if (this.data.status == '0') {
      this.rejectBtn = true
    }
    if (this.data.status == '2') {
      this.rejectBtn = false
    }
    let mainContent = doc.getElementById('hide_div').remove()
    this.html = doc.documentElement.innerHTML
  }

  ngAfterViewInit(): void {
    const parser = new DOMParser()
    const doc = parser.parseFromString(this.html, 'text/html')
    this.isApproved = doc
      .getElementsByClassName('IsApproved')[0]
      .innerHTML.toString()
  }

  approveAggregator() {
    this.loader.start()
    var obj = {
      idAggregatorData: this.idtoApprove
    }
    this._httpService
      .approveAggregator(obj)
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(
        res => {
          this.dialogRef.close('approved')
          if (this.isApproved == '1') {
            this.tostr.success('MOU Resend Succesfully')
          } else {
            if (this.data.id.aggregatorType == 'PACS') {
              this.tostr.success(
                'Aggregator approved successfully'
              )
            } else {
              this.tostr.success(
                'Aggregator approved & MOU is sended successfully'
              )
            }

          }
        },
        err => {
          console.log('error', err)
          this.loader.stop()
        }
      )
  }

  convetToPDF() {
    this.loader.start()
    var canvas = document.getElementById('content')
    html2canvas(canvas).then(function (canvas) {
      var imgWidth = 212
      var pageHeight = 290
      var imgHeight = (canvas.height * imgWidth) / canvas.width
      var heightLeft = imgHeight
      var doc = new jsPDF('p', 'mm')
      var position = 0
      var pageData = canvas.toDataURL('image/jpeg', 1.0)
      var imgData = encodeURIComponent(pageData)
      doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
      doc.setLineWidth(5)
      doc.setDrawColor(255, 255, 255)
      doc.rect(0, 0, 210, 295)
      heightLeft -= pageHeight

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight
        doc.addPage()
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
        doc.setLineWidth(5)
        doc.setDrawColor(255, 255, 255)
        doc.rect(0, 0, 210, 295)
        heightLeft -= pageHeight
      }
      doc.save('MOU.pdf')
    })
    setTimeout(() => {
      this.loader.stop()
    }, 3000)
  }

  ngOnDestroy(): void {
    this.isAlive = false
  }

  rejectAggregator() {
    let dialogRef = this.dialog.open(AggregatorRejectModal, {
      width: 'auto',
      height: 'auto',
      position: { top: '10px' },
      data: this.data.id
    })

    dialogRef
      .afterClosed()
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(result => {
        if (result == 'rejected') {
          this.tostr.success('Aggregator Rejected Successsfully')
          this.dialogRef.close('updated')
        }
      })
  }
  checkAgree(value) {
    if (value.checked == true) {
      this.disabled = false
    } else {
      this.disabled = true
    }
  }
  agreeAggregator() {
    this.loader.start()
    var user = JSON.parse(sessionStorage.getItem('currentUser'))
    var tabs = user.tabName
    var redirect = this.authenticationService.redirectUrl
      ? this.authenticationService.redirectUrl
      : `/${tabs[0]}`
    var url = redirect.toLowerCase()

    this.authenticationService
      .resendMOU(user.idAggregatorData)
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(res => {
        if (res['data'] == 1) {
          this.tostr.success(res.message)
          this.loader.stop()
          this.router.navigate([url])
          this.dialogRef.close()
        }
      },
        err => {
          this.tostr.error(err)
          this.loader.stop()
          this.dialogRef.close()
        }
      )
  }

  resendAggregator(idAggregator) {
    this.authenticationService
      .resendMOU(idAggregator.idAggregatorData)
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(res => {
        if (res['data'] == 1) {
          this.tostr.success(`${res.message}!!!`)
          this.dialogRef.close()
        } else {
          this.tostr.warning(res.message)
          this.dialogRef.close()
        }
      })
  }
}
